import React, { useContext, useState } from 'react';
import StepButtons from '../../common/StepButtons';
import { UserContext } from '../../../context/UserContext';
import { idVerificationConsent } from '../../../service/api';

const IdVerification = ({ handleGotoPrev, handleGotoNext }) => {
  const { error, updateContext } = useContext(UserContext);
  const [agree, setAgree] = useState(false);

  const handleContinue = async () => {
    if (!agree) return;
    updateContext({ loading: true, error: '' });
    try {
      const res = await idVerificationConsent({ consent: true });
      if (res && res.data) {
        updateContext({ token: res.data.Token, content: res.data.Content });
      }
      handleGotoNext();
    } catch (e) {
      if (e.response?.data?.error) {
        updateContext({ error: e.response.data.error });
      }
    }
    updateContext({ loading: false });
  };

  return (
    <div className="custom-steps company-identification id-verification-step">
      <div className='custom-navigation-block'>
        <span>ID Verification Consent</span>
      </div>
      <div className="block-position-center">
        <div className="business-list">
          <div className="form-step-wrapper form-step-wrapper-two">
            <div className="form-group">
              <div className="form-info-block">
                <span>ID Verification Consent</span>
                <p>This step is required to verify your identity with official records.</p>
              </div>

              <div className="consent-box">
                <p>
                  UnLock uses third party services to verify the identity of all applicants. Your explicit consent is
                  required to be able to perform these verifications.
                </p>
                <p>
                  I confirm that I am authorised to provide the personal details presented and I consent to my information
                  being checked with the document issuer or official record holder via third party systems and services
                  for the purpose of confirming my identity.
                </p>
              </div>

              <div className={`form-group confirm-checkbox-group`}>
                <div className="form-field">
                  <div className="form-field formCustomCheckBox mb0">
                    <input
                      id={'agree'}
                      name={'agree'}
                      type={'checkbox'}
                      checked={agree}
                      onChange={(e) => setAgree(e.target.checked)}
                    />
                    <div className="form-field-desc">
                      <strong>I give my consent</strong>
                      <div className="text-xs">Tick to give consent</div>
                    </div>
                  </div>
                </div>
              </div>

              {error && (
                <div className="flex w-full">
                  <p className="error-text-no-flex custom-error-text" dangerouslySetInnerHTML={{ __html: error }}></p>
                </div>
              )}

              <div className="flex w-full">
                <div className="custom-button-form-result">
                  <StepButtons nextBtnText="Continue" handleGotoNext={handleContinue} isNextDisabled={!agree} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IdVerification;
